import { HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest } from '../api/HealthSystemApi';
import { SearchCompareViewModel } from '../models/common';
import ApiService from './ApiService';

export class CompareSearchService {
  private apiService = new ApiService();

  getAllAsync = async (farmId: string): Promise<SearchCompareViewModel[]> => {
    const result = await this.apiService.api.savedComparisons.savedComparisonsGetAll();
    return result.data
      .filter((item) => item.farmId === farmId)
      .map((item) => ({
        id: item.id,
        name: item.name,
        timestamp: item.createdAt,
        // The API types the stored query as `any`; it is whatever saveQueryAsync sent.
        query: item.query as HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest
      }));
  };

  saveQueryAsync = async (
    _farmId: string,
    // Only ever used to prefix the auto-generated name below, and it is a JWT claim that a
    // non-farm token does not carry - so an absent farm number just yields a bare timestamp
    // rather than blocking the save.
    farmNumber: string | undefined,
    query: HealthSystemDomainAnimalsResultAnimalsFarmSearchRequest,
    name?: string | null
  ) => {
    const now = new Date();
    const timestamp = now.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
    const fallbackName = farmNumber ? `${farmNumber} ${timestamp}` : timestamp;

    const resolvedName = (name ?? '').trim().length > 0 ? (name as string).trim() : fallbackName;

    await this.apiService.api.savedComparisons.savedComparisonsCreate({
      name: resolvedName,
      query
    });
  };

  getByIdsAsync = async (farmId: string, ids: string[]): Promise<SearchCompareViewModel[]> => {
    const allData = await this.getAllAsync(farmId);
    return allData.filter((item) => ids.includes(item.id));
  };

  deleteAsync = async (_farmId: string, id: string) => {
    await this.apiService.api.savedComparisons.savedComparisonsDelete({ id });
  };
}

export default CompareSearchService;
